import { computed, inject, Injectable } from '@angular/core';

import { TicketsDataService } from '@tellent-ask-hr/tickets-logic';

@Injectable({ providedIn: 'root' })
export class TicketsChatService {
  private readonly ticketsDataService = inject(TicketsDataService);
  private readonly VIEW_ID = 'ask_tickets:hr_assistant';

  public isFeatureAvailable() {
    this.loadChatCounter();
    const viewCounter = this.getChatCounter();
    return computed(() => {
      const value = viewCounter();
      if (!value) return false;

      return value.count > 0;
    });
  }

  public loadChatCounter() {
    this.ticketsDataService.loadCounters([this.VIEW_ID]);
  }

  public getChatCounter() {
    return this.ticketsDataService.getCounter(this.VIEW_ID);
  }
}
